import React from 'react';
import GenericTableTemplate from 'Views/Page/Content/Templates/GenericTableTemplate';
import {
  FDBox,
  Tabs,
  Table,
  FDStack,
  FDBackButton,
  FDBodyText,
} from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { dayOfMonth, fullDateAtTime } from 'Consts/DateFormats';
import {
  BoolColumn,
} from 'Views/Page/Content/Templates/GenericTableTemplate/MainContent/ItemListPicker/ItemList/ItemTable/boolColumn';
import { ActionLozenge } from 'Views/Page/Content/Templates/ManagedAccountModelUpdateRequestPageTemplate/ActionLozenge';
import {
  SelectedModelLozenge,
} from 'Views/Page/Content/Templates/ManagedAccountModelUpdateRequestPageTemplate/SelectedModelLozenge';
import { dataAttrs } from 'Helpers/Testing';


const metaOverrideSet = buildFacetDesignOverride()
  .overrideAll({
    _component: () => Table.BodyCellText,
  }, {
    ordinal: 200,
  })
  .typeOverride('number', {
    _component: () => Table.BodyCellNumber,
  }, {
    ordinal: 200,
  })
  .typeOverride('date', {
    _formatString: dayOfMonth,
  }, {
    ordinal: 200,
  })
  .typeOverride('bool', {
    _component: () => BoolColumn,
  }, overrideReadOnly)
  .override({ isDateTime: true }, {
    _displayTime: true,
    _formatString: fullDateAtTime,
  }, {
    ordinal: 200,
  })
  .nameOverride('action', {
    _component: () => ActionLozenge,
  }, {
    ordinal: 300,
  })
  .nameOverride('selectedModel', {
    _component: () => SelectedModelLozenge,
  }, {
    ordinal: 300,
  });

const ManagedAccountModelUpdateRequestWithTabs = () => {
  const [selectedTab, setSelectedTab] = React.useState(fr.relationships.allItems.name);
  const { pageContentResource, loadPageContentLink } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleTabClick = async (tab) => {
    try {
      await pageContentResource.withRelationship(fr.relationships[tab].name, (rel) => {
        return loadPageContentLink(rel.link('related'));
      }, () => {
        return null;
      });
    } catch (err) {
      displayErrorMessage(err, err?.errors || 'Failed to filter model update requests.');
    }
  };

  const noModelAssignedPrompt = pageContentResource.relationship(fr.relationships.noModelAssignedItems.name).meta('prompt');
  const modelDoesNotMatchPrompt = pageContentResource.relationship(fr.relationships.modelDoesNotMatchItems.name).meta('prompt');
  const inTradingItemsPrompt = pageContentResource.relationship(fr.relationships.inTradingItems.name).meta('prompt');
  const itemsPrompt = pageContentResource.relationship(fr.relationships.allItems.name).meta('prompt');

  return (
    <FDStack>
      <GenericTableTemplate
        itemListMetaOverride={metaOverrideSet}
        mainContentSubHeader={(
          <FDBox paddingY={1} paddingX={2}>
            <FDStack direction="column" width="100%">
              {pageContentResource.withRelationship(
                fr.relationships.modelUpdateRequestAggregatePage.name,
                (rel) => (
                  <FDStack spacing={2} alignItems={'center'} justifyContent={'flex-start'} width={'100%'} paddingY={1}>
                    <FDBackButton
                      onClick={() => loadPageContentLink(rel.link('related'))}
                      {...dataAttrs('back-btn')}
                      size="md"
                    />
                    <FDBodyText size={'lg'} color={'textPrimary'} value={rel.meta('prompt')} />
                  </FDStack>
                ),
                () => null,
              )}
              <Tabs.Horizontal
                onChange={(_event, tabValue) => {
                  setSelectedTab(tabValue);
                  return handleTabClick(tabValue);
                }}
                value={selectedTab}
                options={[
                  { value: fr.relationships.allItems.name, label: itemsPrompt },
                  { value: fr.relationships.noModelAssignedItems.name, label: noModelAssignedPrompt },
                  { value: fr.relationships.modelDoesNotMatchItems.name, label: modelDoesNotMatchPrompt },
                  { value: fr.relationships.inTradingItems.name, label: inTradingItemsPrompt },
                ]}
              />
            </FDStack>
          </FDBox>
      )}
      />
    </FDStack>
  );
};

export default ManagedAccountModelUpdateRequestWithTabs;
